// const dataStructure = {
//     prices: [
//         {
//             description: String, // from stripe - eg: "Remaining time on 2 × WhatsApp File Top Up after 01 Sep 2023"
//             quantity: Number, // from stripe
//             start_time: Date, // from stripe - period.start
//             end_time: Date, // from stripe - period.end
//             plan_unit_amount: Float, // from stripe - plan.unit_amount (eg: 14.9 )
//             amount: Float, // from stripe (the prorated amount incl. tax eg: 13.07)
//             amount_excluding_tax: Float, // from stripe (the prorated amount eg: 13.07)

import { parseFromStripe } from "./parseFromStripe";

//             product_name: "WhatsApp File Top Up", // <- EXTRA: need to be inferred from plan
//         },
//     ],
//     subtotal: Float, // from stripe
//     discount_amount: Float, // from stripe
//     total_excluding_tax: Float, // from stripe
//     tax_amount: Float, // from stripe - tax
//     total: Float, // from stripe

//     amount_due: Float, // from stripe (will be 0 if credits > total)

//     billing_cycle: Number, // EXTRA: 1 or 12
//     billing_anchor_date: Date, // EXTRA: upcoming billing date (with time)
// };

const today = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 54559,
    amount_paid: 0,
    amount_remaining: 54559,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695005202,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: {
        id: "di_1NrXTyGSTSE9ZxBoV92NGHX5",
        object: "discount",
        checkout_session: null,
        coupon: {
            id: "JhUx8mKF",
            object: "coupon",
            amount_off: null,
            created: 1692949620,
            currency: null,
            duration: "once",
            duration_in_months: null,
            livemode: false,
            max_redemptions: null,
            metadata: {},
            name: "GROWTH31",
            percent_off: 31.0,
            redeem_by: null,
            times_redeemed: 0,
            valid: true,
        },
        customer: "cus_OXR6bokjAgeGq1",
        end: null,
        invoice: null,
        invoice_item: null,
        promotion_code: null,
        start: 1695005202,
        subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    },
    discounts: [
        "di_1NrXTyGSTSE9ZxBoV92NGHX5",
    ],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_1548cdGSTSE9ZxBo847c75ea",
                object: "line_item",
                amount: -2139,
                amount_excluding_tax: -2139,
                currency: "myr",
                description: "Unused time on Subscription (Monthly) after 18 Sep 2023",
                discount_amounts: [
                    {
                        amount: 0,
                        discount: "di_1NrXTyGSTSE9ZxBoV92NGHX5",
                    },
                ],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1NrXTyGSTSE9ZxBoO1dWCWVk",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1695005202,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 5900,
                    amount_decimal: "5900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "inclusive",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 5900,
                    unit_amount_decimal: "5900",
                },
                proration: true,
                proration_details: {
                    credited_items: {
                        invoice: "in_1NkNMiGSTSE9ZxBoFc7Ff9ld",
                        invoice_line_items: [
                            "il_1NkNMiGSTSE9ZxBoSy2zspKO",
                        ],
                    },
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OXSHx7ZMeCK8Mf",
                tax_amounts: [
                    {
                        amount: -128,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: -2139,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "-2139",
            },
            {
                id: "il_tmp_107d34GSTSE9ZxBo4413fefc",
                object: "line_item",
                amount: 59000,
                amount_excluding_tax: 59000,
                currency: "myr",
                description: "1 × Subscription (Yearly) (at RM590.00 / year)",
                discount_amounts: [
                    {
                        amount: 18290,
                        discount: "di_1NrXTyGSTSE9ZxBoV92NGHX5",
                    },
                ],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1726627602,
                    start: 1695005202,
                },
                plan: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 59000,
                    amount_decimal: "59000",
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 59000,
                    unit_amount_decimal: "59000",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OerClvAPndwFZd",
                tax_amounts: [
                    {
                        amount: 2443,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 40710,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "59000",
            },
            {
                id: "il_tmp_1b4728GSTSE9ZxBo73ad5f7b",
                object: "line_item",
                amount: 14900,
                amount_excluding_tax: 14900,
                currency: "myr",
                description: "1 × WhatsApp File Top Up (at RM149.00 / year)",
                discount_amounts: [
                    {
                        amount: 0,
                        discount: "di_1NrXTyGSTSE9ZxBoV92NGHX5",
                    },
                ],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1726627602,
                    start: 1695005202,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoz0CssG2t",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 14900,
                    amount_decimal: "14900",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoz0CssG2t",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 14900,
                    unit_amount_decimal: "14900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OerCoQLLtaER9w",
                tax_amounts: [
                    {
                        amount: 894,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 14900,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "14900",
            },
        ],
        has_more: false,
        total_count: 3,
        url: "/v1/invoices/upcoming/lines?subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice%5D=price_1LmYneGSTSE9ZxBoV5IU4OIR&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoz0CssG2t&subscription_items%5B2%5D%5Bquantity%5D=1&subscription_items%5B2%5D%5Bdeleted%5D=false&subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_proration_behavior=always_invoice&coupon=JhUx8mKF&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695005202,
    period_start: 1695005202,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: -2121,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1695005202,
    subtotal: 71761,
    subtotal_excluding_tax: 71761,
    tax: 3209,
    test_clock: null,
    total: 56680,
    total_discount_amounts: [
        {
            amount: 18290,
            discount: "di_1NrXTyGSTSE9ZxBoV92NGHX5",
        },
    ],
    total_excluding_tax: 53471,
    total_tax_amounts: [
        {
            amount: 3209,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: 53471,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const nextNoProration = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 56826,
    amount_paid: 0,
    amount_remaining: 56826,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695005221,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: {
        id: "di_1NrXUHGSTSE9ZxBo3RR2rKkP",
        object: "discount",
        checkout_session: null,
        coupon: {
            id: "JhUx8mKF",
            object: "coupon",
            amount_off: null,
            created: 1692949620,
            currency: null,
            duration: "once",
            duration_in_months: null,
            livemode: false,
            max_redemptions: null,
            metadata: {},
            name: "GROWTH31",
            percent_off: 31.0,
            redeem_by: null,
            times_redeemed: 0,
            valid: true,
        },
        customer: "cus_OXR6bokjAgeGq1",
        end: null,
        invoice: null,
        invoice_item: null,
        promotion_code: null,
        start: 1695005221,
        subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    },
    discounts: [
        "di_1NrXUHGSTSE9ZxBo3RR2rKkP",
    ],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_127ca6GSTSE9ZxBo786903f7",
                object: "line_item",
                amount: 59000,
                amount_excluding_tax: 59000,
                currency: "myr",
                description: "1 × Subscription (Yearly) (at RM590.00 / year)",
                discount_amounts: [
                    {
                        amount: 18290,
                        discount: "di_1NrXUHGSTSE9ZxBo3RR2rKkP",
                    },
                ],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1726627621,
                    start: 1695005221,
                },
                plan: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 59000,
                    amount_decimal: "59000",
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 59000,
                    unit_amount_decimal: "59000",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OerCf7lFSWHKUf",
                tax_amounts: [
                    {
                        amount: 2443,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 40710,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "59000",
            },
            {
                id: "il_tmp_1dca08GSTSE9ZxBod97bbb0f",
                object: "line_item",
                amount: 14900,
                amount_excluding_tax: 14900,
                currency: "myr",
                description: "1 × WhatsApp File Top Up (at RM149.00 / year)",
                discount_amounts: [
                    {
                        amount: 0,
                        discount: "di_1NrXUHGSTSE9ZxBo3RR2rKkP",
                    },
                ],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1726627621,
                    start: 1695005221,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoz0CssG2t",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 14900,
                    amount_decimal: "14900",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoz0CssG2t",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 14900,
                    unit_amount_decimal: "14900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OerCRRqSGsZfUT",
                tax_amounts: [
                    {
                        amount: 894,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 14900,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "14900",
            },
        ],
        has_more: false,
        total_count: 2,
        url: "/v1/invoices/upcoming/lines?coupon=JhUx8mKF&subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_proration_behavior=none&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice%5D=price_1LmYneGSTSE9ZxBoV5IU4OIR&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bquantity%5D=1&subscription_items%5B2%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoz0CssG2t&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695005221,
    period_start: 1695005221,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: -2121,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1695005221,
    subtotal: 73900,
    subtotal_excluding_tax: 73900,
    tax: 3337,
    test_clock: null,
    total: 58947,
    total_discount_amounts: [
        {
            amount: 18290,
            discount: "di_1NrXUHGSTSE9ZxBo3RR2rKkP",
        },
    ],
    total_excluding_tax: 55610,
    total_tax_amounts: [
        {
            amount: 3337,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: 55610,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const DiffCycleUpgrade = parseFromStripe(today);
const DiffCycleNoProration = parseFromStripe(nextNoProration);

export const DiffCycleMonthToYearUpgradeExpected = {
    today: DiffCycleUpgrade,
    next: DiffCycleNoProration,
};
